import { AxiosError, AxiosResponse } from "axios";
import { CartService } from "@Api/CartService";
import { TrackingService } from "@Api/TrackingService";
import { CookieManager } from "./CookieManager";

export class Tracking
{
	private readonly cartService: CartService;
	private readonly trackingService: TrackingService;

	constructor()
	{
		this.cartService = new CartService();
		this.trackingService = new TrackingService();
	}

	public AddExperimentToGa = (experimentId): void =>
	{
		if (typeof ga !== "undefined")
		{
			ga("set", "exp", experimentId);
		}
	};

	public IncreaseVisitCount = (): void =>
	{
		const returnVisitorCookie = CookieManager.Cookies.ReturnVisitor;

		//new visit
		let visits = parseInt(CookieManager.GetCookie(returnVisitorCookie.Key, returnVisitorCookie.VisitCount), 10);

		visits = isNaN(visits) ? 0 : visits;
		visits = visits + 1;

		CookieManager.SetInCookie(returnVisitorCookie.Key, returnVisitorCookie.VisitCount, visits.toString(), 365, false);
	};

	public RestoreCart = (ogid): void =>
	{
		this.cartService.RestoreCart(ogid)
			.catch((error) =>
			{
				console.error(error);
			});
	};

	public SubmitPageViewData = (pageViewData): void =>
	{
		if (pageViewData !== null)
		{
			// Set country to lowercase to appease facebook
			// http://helpdesk.fun.local/IT/Ticket/23754
			for (const entry of pageViewData)
			{
				let stopChecking = false;

				if (typeof entry === "object")
				{
					for (const [key] of Object.entries(entry))
					{
						if (key === "country")
						{
							stopChecking = true;
							entry.country = entry.country.toLowerCase();
						}
					}

					if (stopChecking === true)
					{
						break;
					}
				}
			}

			this.trackingService.SubmitWebAPI(pageViewData);
		}
	};

	public VisitCountCheck = (): void =>
	{
		const returnVisitorCookie = CookieManager.Cookies.ReturnVisitor;

		let lastVisitTime = parseInt(CookieManager.GetCookie(returnVisitorCookie.Key, returnVisitorCookie.LastVisitTime),
			10
		);

		/// <summary>Gets or sets the idle time in minutes before the visit count is increased.</summary>
		const returnVisitMinutesIdle = 30;
		const threshold = returnVisitMinutesIdle * 60000;
		const now = new Date().getTime();
		let delta = 0;

		lastVisitTime = isNaN(lastVisitTime) ? 0 : lastVisitTime;
		delta = now - lastVisitTime;

		if (lastVisitTime === 0 || delta > threshold)
		{
			this.IncreaseVisitCount();
		}

		CookieManager.SetInCookie(returnVisitorCookie.Key, returnVisitorCookie.LastVisitTime, now.toString(), 365, false);
	};
}